import { render } from "./HomeMain.vue?vue&type=template&id=049a2f08&scoped=true&ts=true"
import script from "./HomeMain.vue?vue&type=script&lang=ts"
export * from "./HomeMain.vue?vue&type=script&lang=ts"

import "./HomeMain.vue?vue&type=style&index=0&id=049a2f08&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049a2f08"]])

export default __exports__